import * as React from 'react';
import { BrowserRouter, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { CookiesProvider } from 'react-cookie';
import { Helmet } from 'react-helmet';
import routes from '../routes';
import configureStore from '../configureStore';
import { routesMapper } from '../utils/routesMapper';
import MainWrapper from "./Layouts/MainWrapper/MainWrapper";

import favicon from '../images/icons/favicon.png';

const store = configureStore();

const App = () => (
  <Provider store={store}>
    <CookiesProvider>
      <BrowserRouter>
        <MainWrapper>
          <Helmet
            link={[
              { rel: 'shortcut icon', type: 'image/png', href: `${favicon}` }
            ]}/>
          <Switch>
            {routesMapper(routes)}
          </Switch>
        </MainWrapper>
      </BrowserRouter>
    </CookiesProvider>
  </Provider>
);

export default App;
